import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {RestClientService} from './rest-client/rest-client.service';
import {UsState} from './model';
import {HttpParams} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UsStateService {

  constructor(private restClient: RestClientService) {
  }

  public getAll(text: string): Observable<UsState[]> {
    const params = new HttpParams().append('text', text);
    return this.restClient.getWithParams<UsState[]>(`/us-states`, params);
  }
}
